import { CopyIdButton } from '@/components/shared';
import { useInterviewLink } from '../useInterviewLink';

export function InterviewLinkValue({ projectId }: { projectId: string }) {
  const link = useInterviewLink(projectId);
  if (link.isPending) return <span>Loading interview link...</span>;
  if (link.isError) return <span role="status">Interview link is temporarily unavailable</span>;
  if (!link.data?.url) return <span>Not available</span>;
  return (
    <div className="group flex min-w-0 items-start gap-2">
      <a
        href={link.data.url}
        target="_blank"
        rel="noopener noreferrer"
        className="focus-ring min-w-0 break-all rounded-sm font-medium text-neutral-900 hover:text-backoffice-600"
      >
        {link.data.url}
      </a>
      <CopyIdButton value={link.data.url} label="Copy interview link" />
    </div>
  );
}
